/**
 * @generated SignedSource<<11357fbfcf5914a62a41f40d700dacbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMapContributionsManager_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "e9539a9ef05326f3bfd3f30a101b20d1";

module.exports = node;
